import apiClient from "./axios";

const employeeApi = {
  // GET all (pagination + search)
  getAll: async (page = 1, pageSize = 10, search = "") => {
    const response = await apiClient.get("/employees/", {
      params: { page, page_size: pageSize, search },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  //   // GET all by params (pagination + search)
  getForTicketAssignment: async (isITRelated = true) => {
    const response = await apiClient.get("/employees/", {
      params: {
        page: 1,
        page_size: 1000,
        can_manage_ticket_it: isITRelated ? true : undefined,
        can_manage_ticket_non_it: !isITRelated ? true : undefined,
      },
      paramsSerializer: (p) =>
        Object.entries(p)
          .filter(([_, v]) => v !== undefined)
          .map(([k, v]) => `${k}=${v}`)
          .join("&"),
    });
    return response.data;
  },

  // GET by ID
  getById: async (id) => {
    const response = await apiClient.get(`/employees/${id}/`);
    return response.data;
  },

  // CREATE
  create: async (formData) => {
    const response = await apiClient.post("/employees/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // UPDATE
  update: async (id, formData) => {
    const response = await apiClient.patch(`/employees/${id}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/employees/${id}/`);
    return id;
  },

  // PASSWORD CHANGE BY SUPERADMIN
  changePassword: async (id, newPassword) => {
    const response = await apiClient.patch(
      `/password-reset/superadmin/${id}/`,
      {
        new_password: newPassword,
      }
    );
    return response.data;
  },

  // EXPORT CSV
  exportCsv: async () => {
    const response = await apiClient.get("/employees/export/", {
      responseType: "blob",
    });
    return response.data;
  },

  // IMPORT PREVIEW
  importPreview: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const response = await apiClient.post("/employees/import-preview/", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data; // { preview: [...], total: number, errors: [...] }
  },

  // IMPORT CONFIRM
  importConfirm: async (preview) => {
    const response = await apiClient.post("/employees/import-confirm/", {
      preview,
    });
    return response.data;
  },
};

export default employeeApi;
